module.exports = __webpack_public_path__ + "static/media/jetphotos.57d3d0b5.svg";